import { Form } from 'factorial-form'

class AutoScheduleForm extends Form {
  constructor(values: object = {}) {
    super(
      { ...values },
      {
        start_at: 'string',
        end_at: 'string',
        location_id: 'number',
        employee_id: 'any',
        rest_days_per_week: 'boolean',
        agreement_hours: 'boolean',
        rest_hours_between_shifts: 'boolean',
        max_work_hours_per_day: 'boolean',
      }
    )

    this.setValues({
      rest_days_per_week: true,
      agreement_hours: true,
      rest_hours_between_shifts: true,
      max_work_hours_per_day: true,
      employee_id: [],
    })
  }
}

export { AutoScheduleForm }
